function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import SpzaComponent from './spzaComponent';
import { getAttributes } from '../utils/externalLinkUtils';
import { getWindow } from '@shared/services/window';
import { Constants } from '@shared/utils/constants';
import { logger } from '@src/logger';
/**
 * Behaves similar with HTML DOM <a></a>
 * But dedicated to open a new tab, and log telemetry for link clicked.
 * When a link contains a 'mail:to', instead of opening a new tab, showing an email dialog
 */ export class ExternalLink extends SpzaComponent {
    renderImpl() {
        const _this_props = this.props, { href, children, telemetryDetails } = _this_props, rest = _object_without_properties(_this_props, [
            "href",
            "children",
            "telemetryDetails"
        ]);
        const attributes = getAttributes(_object_spread({
            href,
            children
        }, rest));
        return /*#__PURE__*/ _jsx("a", _object_spread_props(_object_spread({}, attributes), {
            onClick: (event)=>{
                var _this_props_onClickHandle, _this_props;
                const payload = {
                    page: getWindow().location.href,
                    action: Constants.Telemetry.Action.Click,
                    actionModifier: Constants.Telemetry.ActionModifier.ExternalLink,
                    details: telemetryDetails || JSON.stringify(href)
                };
                logger.info(payload.details, {
                    action: payload.action,
                    actionModifier: payload.actionModifier
                });
                (_this_props_onClickHandle = (_this_props = this.props).onClickHandle) === null || _this_props_onClickHandle === void 0 ? void 0 : _this_props_onClickHandle.call(_this_props, event);
            },
            children: children
        }));
    }
    constructor(props, context){
        super(props, context), _define_property(this, "context", void 0), _define_property(this, "provider", void 0);
    }
}
